import { Injectable } from '@angular/core';
declare var jquery: any;
declare var $: any;

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class CommonService {

  constructor() { }

  RenderListingCarousel() {
    setTimeout(() => { // fat arrow
      $('.listing-carousel').owlCarousel({
        autoPlay: false,
        navigation: true,
        slideSpeed: 800,
        items: 1,
        itemsDesktop: [1239, 1],
        itemsTablet: [991, 1],
        itemsMobile: [767, 1]
      });

      // $('.carousel').owlCarousel({
      //   autoPlay: false,
      //   navigation: true,
      //   slideSpeed: 600,
      //   items: 3,
      //   itemsDesktop: [1239, 3],
      //   itemsTablet: [991, 2],
      //   itemsMobile: [767, 1]
      // });

      // $('.listing-carousel').each(function() {
      //   $(this).data('owlCarousel').reload();
      // });

      // tslint:disable-next-line: only-arrow-functions
      $('.owl-next, .owl-prev').on('click', function(e) {
        e.preventDefault();
        $('.listing-carousel').each(function() {
          $(this).data('owlCarousel').reload();
        });
      });
    });
  }


  GridLayoutSwitcher() {
    setTimeout(() => {
      // tslint:disable-next-line: prefer-const
      let listingsContainer = $('.listings-container');
      if ($(listingsContainer).is('.list-layout')) {
        // owlReload();
        $('.layout-switcher a.grid, .layout-switcher a.grid-three').removeClass('active');
        $('.layout-switcher a.list').addClass('active');
      }
      if ($(listingsContainer).is('.grid-layout')) {
        //  owlReload();
        $('.layout-switcher a.grid').addClass('active');
        $('.layout-switcher a.grid-three, .layout-switcher a.list').removeClass('active');
        gridClear(2);
      }
      if ($(listingsContainer).is('.grid-layout-three')) {
        // owlReload();
        $('.layout-switcher a.grid, .layout-switcher a.list').removeClass('active');
        $('.layout-switcher a.grid-three').addClass('active');
        gridClear(3);
      }

      function gridClear(gridColumns) {
        $(listingsContainer).find('.clearfix').remove();
        $('.listings-container > .listing-item:nth-child(' + gridColumns + 'n)').after('<div class="clearfix"></div>');
      }
      // tslint:disable-next-line: prefer-const
      let resizeObjects = $('.listings-container .listing-img-container img, .listings-container .listing-img-container');

      function listLayout() {
        if ($('.layout-switcher a').is('.list.active')) {
          $(listingsContainer).each(function() {
            $(this).removeClass('grid-layout grid-layout-three');
            $(this).addClass('list-layout');
          });
          $('.listing-item').each(function() {
            // tslint:disable-next-line: prefer-const
            let listingContent = $(this).find('.listing-content').height();
            $(this).find(resizeObjects).css('height', '' + listingContent + '');
          });
        }
      }
      listLayout();
      // tslint:disable-next-line: only-arrow-functions
      $(window).on('load resize', function() {
        listLayout();
      });
      // tslint:disable-next-line: only-arrow-functions
      $('.layout-switcher a.grid').on('click', function(e) {
        gridClear(2);
      });

      function gridLayout() {
        if ($('.layout-switcher a').is('.grid.active')) {
          $(listingsContainer).each(function() {
            $(this).removeClass('list-layout grid-layout-three');
            $(this).addClass('grid-layout');
          });
          $('.listing-item').each(function() {
            $(this).find(resizeObjects).css('height', 'auto');
          });
        }
      }
      gridLayout();
      // tslint:disable-next-line: only-arrow-functions
      $('.layout-switcher a.grid-three').on('click', function(e) {
        gridClear(3);
      });

      function gridThreeLayout() {
        if ($('.layout-switcher a').is('.grid-three.active')) {
          $(listingsContainer).each(function() {
            $(this).removeClass('list-layout grid-layout');
            $(this).addClass('grid-layout-three');
          });
          $('.listing-item').each(function() {
            $(this).find(resizeObjects).css('height', 'auto');
          });
        }
      }
      gridThreeLayout();
      // tslint:disable-next-line: only-arrow-functions
      $(window).on('resize', function() {
        $(resizeObjects).css('height', '0');
        listLayout();
        gridLayout();
        gridThreeLayout();
      });
      // tslint:disable-next-line: only-arrow-functions
      $(window).on('load resize', function() {
        // tslint:disable-next-line: prefer-const
        let winWidth = $(window).width();
        if (winWidth < 992) {
          gridClear(2);
        }
        if (winWidth > 992) {
          if ($(listingsContainer).is('.grid-layout-three')) {
            gridClear(3);
          }
          if ($(listingsContainer).is('.grid-layout')) {
            gridClear(2);
          }
        }
        if (winWidth < 768) {
          if ($(listingsContainer).is('.list-layout')) {
            $('.listing-item').each(function() {
              $(this).find(resizeObjects).css('height', 'auto');
            });
          }
        }
        if (winWidth < 1366) {
          if ($('.fs-listings').is('.list-layout')) {
            $('.listing-item').each(function() {
              $(this).find(resizeObjects).css('height', 'auto');
            });
          }
        }
      });


      $('.layout-switcher a').on('click', function(e) {
        e.preventDefault();
        const switcherButton = $(this);
        switcherButton.addClass('active').siblings().removeClass('active');
        $(resizeObjects).css('height', '0');

        gridLayout();
        gridThreeLayout();
        listLayout();
      });
    }, 1000);
  }
}
